const config = {
  url: "https://backend2.assur-trade.ma/api",
  // url: "http://localhost:8000/api",
  jwt_token_name: "access_token",
};
export default config;
